export const environment = {
  production: false,
  sso: false,
  local: false,
  SSO_STRATEGY: "OAUTH2",
  tenant: "",
  keycloak: {
    url: 'https://fns-stg.comune.napoli.it',
    context: "sp",
    realm: 'service-provider',
    clientId: 'teleforumfor-web',
    clientSecret:"",
    logoutRedirectUri: window.location.protocol + '//' + window.location.host + '/euforlegal/teleforumweb',
    redirectUri: window.location.protocol + '//' + window.location.host + '/euforlegal/teleforumweb',
    outlookAuthEndpoint: window.location.protocol + '//' + window.location.host + '/euforlegal/teleforumweb/#/access-token',
    outlookRefreshTokenEndpoint: window.location.protocol + '//' + window.location.host + '/euforlegal/teleforumweb/#/refresh-token',
  },
  url: window.location.href.slice(0,window.location.href.indexOf('/teleforumweb/'))+ '/',
  urlGateway: window.location.href.slice(0,window.location.href.indexOf('/teleforumweb/'))+ '/',
  urlReport: window.location.href.slice(0,window.location.href.indexOf('/teleforumweb/'))+ '/',
  urlFlux: window.location.href.slice(0,window.location.href.indexOf('/teleforumweb/'))+ '/'
};

export function getRedirectUri(tenant:string) {
  return window.location.protocol + '//' + window.location.host + "/" + tenant +'/teleforumweb'
}